import React from "react";
import TooltipsPackage from "../tooltips-package";

import { isPc } from "../utils";

import pcStyles from "../pc.less";
import mobileStyles from "../mobile.less";

const styles = isPc() ? pcStyles : mobileStyles;

interface IconButtonProps {
    title: string;
    icon: string;

    onClick: (e: any) => void;
}

export const IconButton: React.FC<IconButtonProps> = ({ title, icon, onClick }) => (
    <div className={styles.btnWrap} onClick={onClick}>
        <TooltipsPackage options={{ title }}>
            <img src={icon} />
        </TooltipsPackage>
    </div>
);

interface IconSwitchProps {
    titleOn: string;
    titleOff: string;
    iconOn: string;
    iconOff: string;

    value: boolean;
    onChange: (value: boolean) => void;
}

export const IconSwitch: React.FC<IconSwitchProps> = ({ titleOn, titleOff, iconOn, iconOff, value, onChange }) => (
    <div className={styles.btnWrap} onClick={() => onChange(!value)}>
        <TooltipsPackage options={{ title: value ? titleOn : titleOff }}>
            <img src={value ? iconOn : iconOff} />
        </TooltipsPackage>
    </div>
);
